import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b2c50214")

_pushScopeId("data-v-b2c50214")
const _hoisted_1 = { class: "Toast" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "toast" }, {
      default: _withId(() => [
        (_ctx.toast.show)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: ["Toast__container", {
          'Toast__container--dark-theme': _ctx.isDarkTheme,
        }],
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClick(...args)))
            }, _toDisplayString(_ctx.toast.message), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})